import { type Enum } from '@webapp/utils'

export const FinancialAccountTypes = {
  AIRWALLEX_USD: 'AIRWALLEX_USD',
  AIRWALLEX_CAD: 'AIRWALLEX_CAD',
  AIRWALLEX_GBP: 'AIRWALLEX_GBP',
} as const

export type FinancialAccountType = Enum<typeof FinancialAccountTypes>
